import * as cryptoJS from 'crypto-js'

export const encryptAES = (text: string) => {
    const encrypted = cryptoJS.AES.encrypt(
        text,
        cryptoJS.enc.Utf8.parse(`${process.env.REACT_APP_CRYPTO_AES_SECRET}`),
        {
            iv: cryptoJS.enc.Utf8.parse(`${process.env.REACT_APP_CRYPTO_AES_IV}`),
            padding: cryptoJS.pad.Pkcs7,
            mode: cryptoJS.mode.CBC,
            algorithm: cryptoJS.algo.AES,
            blockSize: parseInt(`${process.env.REACT_APP_CRYPTO_AES_BLOCK_SIZE}`),
        },
    ).toString()
    return encrypted
}

export const decryptAES = (textEncrypted: string) => {
    const bytes = cryptoJS.AES.decrypt(
        textEncrypted,
        cryptoJS.enc.Utf8.parse(`${process.env.REACT_APP_CRYPTO_AES_SECRET}`),
        {
            iv: cryptoJS.enc.Utf8.parse(`${process.env.REACT_APP_CRYPTO_AES_IV}`),
            padding: cryptoJS.pad.Pkcs7,
            mode: cryptoJS.mode.CBC,
            algorithm: cryptoJS.algo.AES,
            blockSize: parseInt(`${process.env.REACT_APP_CRYPTO_AES_BLOCK_SIZE}`),
        },
    )
    const decrypted = bytes.toString(cryptoJS.enc.Utf8)

    return decrypted
}
